import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { ApiErrors } from '../../enums';
import { useValidatePixKeysBatchMutation } from '../../services/pixKeysApi';
import { handlePixError } from '../../utils/pixErrorHandler';
const ERRORS_MESSAGES = {
    [ApiErrors.CAN_NOT_VALIDATE_PIX_KEYS]: 'transaction-not-done-try-again-later',
};
export function useValidatePixKeysBatch() {
    const { t } = useTranslation();
    const [trigger] = useValidatePixKeysBatchMutation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [result, setResult] = useState();
    async function validatePixKeysBatch(keys, rethrow) {
        setLoading(true);
        setError(undefined);
        setResult(undefined);
        try {
            const { result: response } = await trigger({ keys }).unwrap();
            setResult(response);
            return response;
        }
        catch (err) {
            const errorMessage = handlePixError({
                error: err,
                translate: t,
                errorMessages: ERRORS_MESSAGES,
                defaultErrorKey: ApiErrors.CAN_NOT_VALIDATE_PIX_KEYS,
            });
            setError(errorMessage);
            if (rethrow) {
                throw new Error(errorMessage);
            }
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        result,
        setResult,
        validatePixKeysBatch,
    };
}
